import React from "react";

import Typography from "@mui/material/Typography";

import type { KeyQuestionFeedItem } from "@app/analytics/Home/types";

import Stack, { Row } from "@rui/Stack";

import BaseHomeFeedItemLayout from "./BaseHomeFeedItemLayout";
import HomeFeedItemVideoClip from "./HomeFeedItemVideoClip";
import { Content } from "./styles";

interface KeyQuestionItemProps extends KeyQuestionFeedItem {
  onClick: (id: string) => void;
}

const KeyQuestionItem = ({ onClick, ...item }: KeyQuestionItemProps) => {
  return (
    <BaseHomeFeedItemLayout {...item} onClick={onClick}>
      <Stack>
        <Row spacing={1.5} paddingBottom={1} justifyContent="space-between">
          <Stack>
            <Content type={item.type}>
              <Typography variant="bodySecondaryReg">{item.text}</Typography>
            </Content>
          </Stack>
          {item.videoClip && (
            <HomeFeedItemVideoClip
              entityId={item.entityId}
              session={item.session}
              videoClip={item.videoClip}
            />
          )}
        </Row>
      </Stack>
    </BaseHomeFeedItemLayout>
  );
};

export default KeyQuestionItem;
